export default {
    PREVIEW_LINK: 'preview-project',
    SUBMIT: "Submit",
    GO_TO_FIRST_PAGE: "Go Back"
}